import { render, staticRenderFns } from "./OfficialFeePaymentInstitution.vue?vue&type=template&id=ac6d0f68&"
import script from "./OfficialFeePaymentInstitution.vue?vue&type=script&lang=js&"
export * from "./OfficialFeePaymentInstitution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports